<template>
  <div class="seasidetms_wrap_pagination col-md-12">
    <ul class="page-numbers" v-if="totalPages > 1">
      <li v-if="categoryPage > 1">
        <a
          href="#prev"
          class="prev page-numbers"
          @click.stop.prevent="onPrevPage"
        >
          <span class="seasidetms_theme_icon_slide_prev"></span>
        </a>
      </li>
      <li v-for="(n, i) in pages" :key="`p${i}`">
        <span
          v-if="n == categoryPage"
          aria-current="page"
          class="page-numbers current"
        >
          {{ n }}
        </span>
        <span v-else-if="n == null" class="page-numbers dots">…</span>
        <a v-else href="#" class="page-numbers" @click.stop.prevent="onPage(n)">
          {{ n }}
        </a>
      </li>
      <li v-if="totalPages > 1 && categoryPage < totalPages">
        <a
          href="#next"
          class="next page-numbers"
          @click.stop.prevent="onNextPage"
        >
          <span class="seasidetms_theme_icon_slide_next"></span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'CategoryPagination',
  props: {
    total: {
      type: Number,
      required: true,
    },
    event: {
      type: Function,
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.categoryPerPage)
    },
    pages() {
      const pages = []
      for (let i = 1; i <= this.totalPages; i++) {
        // no dots required
        if (this.totalPages < 16) {
          pages.push(i)
          continue
        }
        // first portion of pages
        if (
          (this.categoryPage < 8 && i <= this.categoryPage + 3) ||
          (this.categoryPage > 7 && i < 4)
        ) {
          pages.push(i)
          continue
        }
        // first dots
        if (
          (i === 5 && this.categoryPage === 1) ||
          (i === this.categoryPage + 4 &&
            this.categoryPage > 1 &&
            this.categoryPage < 8) ||
          (i === 4 && this.categoryPage > 7)
        ) {
          pages.push(null)
          continue
        }
        // middle portion of pages
        if (
          i > this.categoryPage - 3 &&
          i < this.categoryPage + 4 &&
          this.categoryPage > 5
        ) {
          pages.push(i)
          continue
        }
        // second dots
        if (
          i === this.totalPages - 4 &&
          this.categoryPage > 7 &&
          this.categoryPage < this.totalPages - 4
        ) {
          pages.push(null)
          continue
        }
        // last portion of pages
        if (i > this.totalPages - 3) {
          pages.push(i)
          continue
        }
      }
      return pages
    },
    ...mapGetters(['categoryPage', 'categoryPerPage']),
    ...mapActions([]),
  },
  methods: {
    updatePath(n) {
      const { query, path } = this.$route
      const isFirst = n === 1

      if (isFirst) {
        delete query.page
      } else {
        query.page = n
      }

      const queryEntries = Object.entries(query)

      if (queryEntries.length || isFirst) {
        const queries = queryEntries.map(([key, value]) => `${key}=${value}`)
        const helper = queryEntries.length ? '?' : ''
        const newPath = `${path}${helper}${queries.join('&')}`
        history.pushState(query, null, newPath)
      }
    },
    onPrevPage() {
      this.$store.dispatch('resetScroll')
      const n = Number(this.categoryPage) - 1
      this.setCategoryPage(n)
      this.event()
      this.updatePath(n)
    },
    onNextPage() {
      this.$store.dispatch('resetScroll')
      const n = Number(this.categoryPage) + 1
      this.setCategoryPage(n)
      this.event()
      this.updatePath(n)
    },
    onPage(n) {
      this.$store.dispatch('resetScroll')
      this.setCategoryPage(n)
      this.event()
      this.updatePath(n)
    },
    ...mapMutations(['setCategoryPage']),
  },
  /*beforeUpdate() {
      this.totalPages = Math.ceil(this.total / this.categoryPerPage)
    },*/
}
</script>

<style lang="scss" scoped>
a.page-numbers {
  color: #337ab7;
}
a.page-numbers.prev,
a.page-numbers.next {
  color: #333;
}
</style>
